
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { Category } from "./types";

interface CategoryStatsProps {
  categories: Category[];
  isLoading: boolean;
  handleEditCategory: (category: Category) => void;
}

const CategoryStats = ({ categories, isLoading, handleEditCategory }: CategoryStatsProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {categories.map((category) => (
        <Card key={category.id}>
          <CardHeader>
            <CardTitle>{category.name}</CardTitle>
            <CardDescription>{category.slug}</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span>Prompts:</span>
                <span className="font-medium">{category.promptCount}</span>
              </div>
              <div className="flex justify-between">
                <span>Subcategories:</span>
                <span className="font-medium">{category.children?.length || 0}</span>
              </div>
              {category.parent && (
                <div className="flex justify-between">
                  <span>Parent:</span>
                  <span className="font-medium">{category.parent.name}</span>
                </div>
              )}
            </div>
          </CardContent>
          <CardFooter className="justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleEditCategory(category)}
            >
              <Edit className="h-4 w-4 mr-2" />
              Edit
            </Button>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};

export default CategoryStats;
